module.exports = __webpack_public_path__ + "static/media/play-icon.e1dbae5c.svg";